import { createFileRoute, Link } from "@tanstack/react-router";
import { adminGuardHOC } from "@/app/hooks/useAdminGuard";

export const Route = createFileRoute("/admin/")({
  component: adminGuardHOC(AdminDashboard),
});

function AdminDashboard() {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Admin Dashboard</h1>
        <p className="text-gray-600">Manage your Team Dash instance</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Analytics Card */}
        <Link
          to="/admin/analytics"
          className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
              <span className="text-2xl">📈</span>
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">Analytics</h2>
              <p className="text-sm text-gray-500">View usage metrics</p>
            </div>
          </div>
          <p className="text-gray-600">
            Track how teammates interact with pages, components, and key actions.
          </p>
        </Link>

        {/* Integrations Card */}
        <Link
          to="/admin/integrations"
          className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
              <span className="text-2xl">🔌</span>
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">Integrations</h2>
              <p className="text-sm text-gray-500">Manage data sources</p>
            </div>
          </div>
          <p className="text-gray-600">
            Configure and monitor ETL processes for Notion, Slack, and other integrations.
          </p>
        </Link>

        {/* Users Card */}
        <Link
          to="/admin/users"
          className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
              <span className="text-2xl">👥</span>
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">Users</h2>
              <p className="text-sm text-gray-500">Manage access</p>
            </div>
          </div>
          <p className="text-gray-600">
            Manage user accounts, invite external collaborators, and control access.
          </p>
        </Link>

        {/* Settings Card (Future) */}
        <div className="bg-white rounded-lg shadow-md p-6 opacity-50">
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mr-4">
              <span className="text-2xl">⚙️</span>
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">Settings</h2>
              <p className="text-sm text-gray-500">Coming soon</p>
            </div>
          </div>
          <p className="text-gray-600">Configure system settings and preferences.</p>
        </div>
      </div>

      {/* Navigation */}
      <div className="mt-8">
        <Link
          to="/"
          className="inline-flex items-center text-blue-600 hover:text-blue-800 transition-colors"
        >
          <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <title>Back arrow</title>
            <path
              fillRule="evenodd"
              d="M7.707 14.707a1 1 0 01-1.414 0L3.586 12l2.707-2.707a1 1 0 011.414 1.414L6.414 12l1.293 1.293a1 1 0 010 1.414z"
              clipRule="evenodd"
            />
            <path
              fillRule="evenodd"
              d="M3 12a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
